import { t } from '@ankr.com/common';

interface IError {
  message?: string;
}

export type TError = Error | IError | unknown;

/**
 * Returns a error message from the provided error.
 *
 * @param error - The error object to extract the message from.
 * @returns The extracted error message or a default unknown error message.
 */
export const getErrorMessage = (error: TError): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return String(error.message);
  }

  if (typeof (error as IError)?.message === 'string') {
    return String((error as IError).message);
  }

  return t('error.unknown');
};
